import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, money, errMsg } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["paid", "processing", "shipped", "delivered", "cancelled"];

export function AdminOrders({ onChange }) {
  const [orders, setOrders] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const load = () => api.get("/admin/orders").then((r) => setOrders(Array.isArray(r.data) ? r.data : [])).catch(() => setOrders([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (o, status) => {
    try {
      await api.patch(`/admin/orders/${o.id}`, { status });
      toast(`${o.number} marked ${status}`);
      load(); onChange?.();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const list = (orders || []).filter((o) => showAll || o.payment_status === "paid");

  return (
    <div data-testid="admin-orders">
      <label className="mb-4 flex items-center gap-2 text-sm text-[var(--ink-soft)]">
        <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} data-testid="admin-orders-show-unpaid" /> Include unpaid / abandoned checkouts
      </label>
      {orders && list.length === 0 && <p className="py-12 text-[var(--ink-soft)]" data-testid="admin-orders-empty">No orders yet.</p>}
      <div className="space-y-3">
        {list.map((o) => (
          <div key={o.id} className="grid gap-4 rounded-2xl border border-[var(--line)] p-5 md:grid-cols-12 md:items-center" data-testid={`admin-order-${o.number}`}>
            <div className="md:col-span-3">
              <p className="font-mono-x text-sm font-medium">{o.number}</p>
              <p className="text-xs text-[var(--ink-soft)]">{new Date(o.created_at).toLocaleString()}</p>
            </div>
            <div className="text-sm md:col-span-4">
              <p className="font-medium">{o.shipping?.name} · {o.email}</p>
              <p className="text-xs text-[var(--ink-soft)]">{o.shipping?.address}, {o.shipping?.city} {o.shipping?.postal_code}, {o.shipping?.country}</p>
              <p className="mt-1 text-xs text-[var(--ink-soft)]">{o.items.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
            </div>
            <div className="text-sm font-semibold md:col-span-2">{money(o.total)}</div>
            <div className="md:col-span-3">
              {o.payment_status === "paid" ? (
                <Select value={o.status} onValueChange={(v) => setStatus(o, v)}>
                  <SelectTrigger className="rounded-full capitalize" data-testid={`admin-order-status-${o.number}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
                </Select>
              ) : <span className="text-xs text-[var(--ink-soft)]">Awaiting payment</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
